import React from "react";
import {
  Button,
  Form,
  FormGroup,
  Label,
  Col,
  Container,
  Row
} from "reactstrap";

import SelectListComponent from "../utils/selectList";

const SearchPanel = ({
  contentErrorText,
  categories,
  selectedFilterMode,
  onFilterModeValueChange,
  onMultiValueChange,
  onSearch,
  startDateChange,
  endDateChange,
  onSelectedFilterValuesChange,
  filterValueKey,
  filterOptions,
  filterLabelKey,
  filterValues
}) => {
  return (
    <Form onSubmit={e => e.preventDefault()}>
      <Container>
        <Row>
          <Col xs="6" sm="4">
            <FormGroup className="mb-4">
              <Label>Categories</Label>
              <SelectListComponent
                data={categories}
                valueKey="Id"
                textField="Name"
                selectValue={selectedFilterMode}
                onValueChange={onFilterModeValueChange}
                clearable={false}
              />
            </FormGroup>
          </Col>
          <Col xs="6" sm="6">
            <FormGroup className="mb-4">
              <Label>Search Box</Label>
              <SelectListComponent
                data={filterOptions}
                multiSelectMode={true}
                selectValue={filterValues}
                valueKey={filterLabelKey}
                textField={filterValueKey}
                onValueChange={onSelectedFilterValuesChange}
              />
              <span style={{ color: "red" }}>{contentErrorText}</span>
            </FormGroup>
          </Col>
          <Col xs="6" sm="1">
            <label>&nbsp;</label>
            <Button className="btn-avi-primary" onClick={() => onSearch(1)}>
              Search
            </Button>
          </Col>
        </Row>
      </Container>
    </Form>
  );
};

export default SearchPanel;



// WEBPACK FOOTER //
// ./src/views/makerChecker/search_panel.js